import { render, staticRenderFns } from "./FastBuyProduct.vue?vue&type=template&id=b67f323e&"
import script from "./FastBuyProduct.vue?vue&type=script&lang=js&"
export * from "./FastBuyProduct.vue?vue&type=script&lang=js&"
import style0 from "./FastBuyProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports